export default __webpack_public_path__ + "c2c0e5fa8323e2c5c1f54f20afda51b8.js";